import React from "react";
import { connect } from "react-redux";
import withHOC from "../../HOC/HOC";
import { bindActionCreators } from "redux";
import Evidence from "./Evidence";
import { loanValidateAction, setEvidenceAction, updateDocPrefillDataAction, updateLoanStatusAction, uploadEvidenceDocumentAction } from "../CreateLoan/CreateLoanAction";
import { API_ERROR_CODE, OPERATION_STATUS } from "../../config/axios.init";
import Utility from "../../utils/Utility";
import { Strings } from "../../resources/i18n/i18n";
import { LOAN_APPLICATION_STATUS } from "../../constants/appConstants";
import { deleteEvidenceDocumentAction } from "../AnalystApproval/AnalystApprovalAction";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
import { Row } from "react-bootstrap";
import { LOAN_TYPES } from "../AnalystApproval/Constants";
import { EVIDENCE_SECTIONS_OBJECT } from "../CreateLoan/CreateLoanConstants";
import UserModal from "../CustomUIComponents/UserModal/UserModal";

class EvidenceContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isUploading: false,
            uploadProgress: 0,
            totalFiles: 0,
            uploadedFiles: 0,
            errorMessage: "",
            toShowToast: false,
            successToastMessage: "",
            level: "",
            showConfirmation: false,
        }
    }

    getFileType = (file) => {
        if (file) {
            let fileExtension = Utility.getFileExtension(file);
            if (fileExtension === "pdf") {
                return "PDF";
            } else if (fileExtension === "jpg") {
                return "JPG";
            } else if (fileExtension === "jpeg") {
                return "JPEG";
            } else if (fileExtension === "png") {
                return "PNG";
            }
        }
        return "JPEG";
    };

    uploadFileSequentially = async (evidenceDetails, callback) => {
        let loanApplicationId = this.props.applyLoanConfig.loanApplicationId;

        if (!loanApplicationId) {
            callback(Strings("applicationIdRequired"));
            return;
        }

        const allFiles = [];
        if (evidenceDetails.LOCAL_PHOTO && evidenceDetails.LOCAL_PHOTO.length > 0) {
            evidenceDetails.LOCAL_PHOTO.forEach((photo, index) => {
                allFiles.push({
                    file: photo.file,
                    type: EVIDENCE_SECTIONS_OBJECT.LOCAL_PHOTO,
                    category: EVIDENCE_SECTIONS_OBJECT.LOCAL_PHOTO,
                    index: index + 1
                });
            });
        }

        if (evidenceDetails.INVOICE && evidenceDetails.INVOICE.length > 0) {
            evidenceDetails.INVOICE.forEach((invoice, index) => {
                allFiles.push({
                    file: invoice.file,
                    type: EVIDENCE_SECTIONS_OBJECT.INVOICE,
                    category: EVIDENCE_SECTIONS_OBJECT.INVOICE,
                    index: index + 1
                });
            });
        }

        // Add PHOTOID
        if (evidenceDetails.PHOTOID && evidenceDetails.PHOTOID.length > 0) {
            evidenceDetails.PHOTOID.forEach((photoId, index) => {

                const photoType = index === 0 ? EVIDENCE_SECTIONS_OBJECT.PHOTOID_FRONT : EVIDENCE_SECTIONS_OBJECT.PHOTOID_BACK;
                allFiles.push({
                    file: photoId.file,
                    type: photoType,
                    category: photoType,
                    index: ""
                });
            });
        }


        if (evidenceDetails.EXTERNAL_INVOICE && evidenceDetails.EXTERNAL_INVOICE.length > 0) {
            evidenceDetails.EXTERNAL_INVOICE.forEach((externalInvoice, index) => {
                allFiles.push({
                    file: externalInvoice.file,
                    type: EVIDENCE_SECTIONS_OBJECT.EXTERNAL_INVOICE,
                    category: EVIDENCE_SECTIONS_OBJECT.EXTERNAL_INVOICE,
                    index: index + 1
                });
            });
        }
        if (evidenceDetails.APPLICATION_SIGNATURE) {
            allFiles.push({
                file: evidenceDetails.APPLICATION_SIGNATURE.file,
                type: EVIDENCE_SECTIONS_OBJECT.APPLICATION_SIGNATURE,
                category: EVIDENCE_SECTIONS_OBJECT.APPLICATION_SIGNATURE,
            });
        }
        if (allFiles.length === 0) {
            callback(Strings("noFilesToUpload"));
            return;
        }

        this.setState({
            isUploading: true,
            uploadProgress: 0,
            totalFiles: allFiles.length,
            uploadedFiles: 0,
        });

        try {
            for (let i = 0; i < allFiles.length; i++) {
                const fileData = allFiles[i];
                if (!fileData.file) {
                    continue;
                }
                const blobUrl = URL.createObjectURL(fileData.file);
                const request = {
                    applicationId: loanApplicationId,
                    type: fileData.category,
                    fileType: this.getFileType(fileData.file),
                    fileUri: blobUrl,
                    fileName: fileData.type + fileData.index + "." + Utility.getFileExtension(fileData.file),
                    fileMimeType: fileData.file.type,
                    fileTypeSpecific: fileData.type + fileData.index
                };
                this.props.showLoadingModal();
                await new Promise((resolve, reject) => {
                    uploadEvidenceDocumentAction(request, (response) => {
                        // Clean up the blob URL after upload
                        URL.revokeObjectURL(blobUrl);
                        if (response.status === OPERATION_STATUS.SUCCESS) {
                            this.props.closeLoadingModal();

                            this.setState(prevState => ({
                                uploadedFiles: prevState.uploadedFiles + 1,
                                uploadProgress: ((i + 1) / allFiles.length) * 100
                            }));
                            resolve();
                        } else if (response.error.code === API_ERROR_CODE.DOCUMENT_ALREADY_UPLOADED) {
                            resolve();
                        } else {
                            this.props.closeLoadingModal();
                            callback(response.error?.message || Strings("uploadFailed"));
                            reject(new Error(response.error?.message || Strings("uploadFailed")));
                        }
                    });
                });
            }


            this.setState({
                isUploading: false,
                uploadProgress: 100,
                errorMessage: ""
            });

            this.props.setEvidenceAction(evidenceDetails);

            this.validateLoan();

        } catch (error) {
            this.setState({
                isUploading: false,
                errorMessage: error.message || Strings("uploadFailed")
            });
        }
    };

    handleDeleteEvidenceDocumentAction = (documentId) => {
        this.setState({ errorMessage: "" });
        this.props.showLoadingModal();
        deleteEvidenceDocumentAction(documentId, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.setState({ errorMessage: "" });
                this.props.closeLoadingModal();
            } else {
                this.setState({
                    errorMessage: response.error.message,
                });
                this.props.closeLoadingModal();
            }
        });
    };

    validateLoan = () => {
        this.props.showLoadingModal();
        loanValidateAction(this.props.applyLoanConfig.loanApplicationId, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.updateLoanStatus();
            } else if (response.error.code === API_ERROR_CODE.INSUFFICIENT_CREDIT_LIMIT) {
                this.updateLoanStatus();
            } else {
                this.setState({ errorMessage: response.error?.message || Strings("loanValidationFailed") });
                this.props.closeLoadingModal();
            }
        });
    }
    scrollToTop = () => {
        window.scrollTo(0, 0);
    };
    updateLoanStatus = () => {
        this.props.showLoadingModal();
        const request = {
            applicationId: this.props.applyLoanConfig.loanApplicationId,
            status: this.props.selectedLoanType === LOAN_TYPES.FACTORING ? LOAN_APPLICATION_STATUS.disbursed : LOAN_APPLICATION_STATUS.submitted
        }
        updateLoanStatusAction(request, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.scrollToTop();
                this.props.updateDocPrefillDataAction(true);
                this.props.closeLoadingModal();
                this.setState({     
                    showConfirmation : true,
                })
            } else {
                this.scrollToTop();
                this.setState({ errorMessage: response.error?.message });
                this.props.closeLoadingModal();
            }

        });
    }

    callAPI = (evidenceDetails, callback) => {
        this.scrollToTop();
        this.uploadFileSequentially(evidenceDetails, callback);
    }

    renderConfirmationModal = () => {
        return (
            <UserModal
                open={this.state.showConfirmation}
                modalCloseOnEsc={false}
                modalCloseOnOverlayClick={false}
                modalShowCloseIcon={false}
                headerText={Strings("SUCCESS")}
                modalText1={Strings("loanFormUpdatedSuccessfully")}
                modalButtonOk={{
                    text: Strings("Proceed"),
                    onClick: () => {
                        this.setState({
                            showConfirmation:false
                        }, () => {
                            this.props.redirectToLoanTypeStep();
                        });
                    },
                }}
            />
        )
    }

    render() {
        return (
            <Row>
                {this.state.toShowToast && (
                    <UserNotification
                        key={this.state.successToastMessage}
                        userNotificationObj={{
                            message: this.state.successToastMessage,
                            level: this.state.level,
                        }}
                    />
                )}
                {this.state.showConfirmation && this.renderConfirmationModal()}
                <Evidence
                    goNext={this.props.handleNext}
                    goBack={this.props.handleBack}
                    callAPI={this.callAPI}
                    evidenceDetails={this.props.evidenceDetails}
                    selectedLoanType={this.props.selectedLoanType}
                    isUploading={this.state.isUploading}
                    uploadProgress={this.state.uploadProgress}
                    totalFiles={this.state.totalFiles}
                    uploadedFiles={this.state.uploadedFiles}
                    errorMessage={this.state.errorMessage}
                    loanApplicationDetails={this.props.allLoanDetails}
                    handleDeleteEvidenceDocumentAction={this.handleDeleteEvidenceDocumentAction}
                    documents={this.props.documents}
                    setEvidenceAction={this.props.setEvidenceAction}
                    disableTextField={this.props.disableTextField}
                    applyLoanConfig={this.props.applyLoanConfig}
                    showLoadingModalState={this.props.showLoadingModalState}
                    scrollToTop={this.scrollToTop}
                />
            </Row>
        )
    }

}
const mapStateToProps = (state) => ({
    singleMiniMart: state.minimartListReducer.singleMiniMart,
    loanApplicationId: state.loanDetailsReducer.loanApplicationId,
    allLoanDetails: state.loanDetailsReducer.allLoanDetails,
    evidenceDetails: state.loanDetailsReducer.evidenceDetails,
    documents: state.loanDetailsReducer.documents,
    applyLoanConfig: state.loanDetailsReducer.applyLoanConfig,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        { setEvidenceAction, uploadEvidenceDocumentAction, updateDocPrefillDataAction },
        dispatch
    );
};
const EvidenceContainerWrapper = withHOC(EvidenceContainer);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EvidenceContainerWrapper);